import { render, staticRenderFns } from "./OrderCardAdditionalInfos.vue?vue&type=template&id=3fe82137&scoped=true&"
import script from "./OrderCardAdditionalInfos.vue?vue&type=script&lang=ts&"
export * from "./OrderCardAdditionalInfos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe82137",
  null
  
)

export default component.exports